<template>
  <div>
    <ContentPage headerText="Why Choose Us">
      <p>
        Sweeping by a professionally trained sweep will not only give you peace of mind, but will also extend the life
        of your flue/liner and could highlight any potential maintenance issues with your appliances, flues, stacks, pots or cowls.
      </p>
    </ContentPage>

    <div class="content">
      <div class="container">
        <div class="sections">

          <div class="top-description">
            <h2>Why Choose Us?</h2>
            <p>
              I will undertake sweeping of your wood/multi/pellet stove, open fire including inglenooks, aga/rayburn, boiler flue or cooking range using traditional rods or more 
              modern power sweeping methods depending on which best suits your requirements. Other services include bird nest removal and bird guards fitted.
            </p>
            <ul class="list">
              <li>
                Fully Trained Gold Master Member of the Guild of Master Chimney Sweeps.
              </li>
              <li>
                Insurance Approved Certificates Issued by the GOMCS
              </li>
              <li>
                Traditional & Power Sweeping methods used
              </li>
              <li>
                Pre-install sweeps
              </li>
              <li>
                Clean professional service
              </li>
              <li>
                Fully insured up to £5 million
              </li>
              <li>
                Free advice
              </li>
            </ul>

            <!-- <div class="chooseUsImageContainer">
              <img src="/images/david_cleaning_woodburner_2.jpg" alt="cleaning woodburner">
            </div>

            <div class="chooseUsImageContainer two">
              <img src="/images/woodburner_in_inglenook.jpg" alt="cleaning inglenook">
            </div> -->
          </div>

          <div class="ChooseUsGallary">
            <img src="/images/woodburner_in_inglenook_3.png" alt="cleaning inglenook">
            <img src="/images/woodburner_in_inglenook_2.png" alt="cleaning inglenook">
            <img src="/images/david_cleaning_woodburner.jpg" alt="cleaning woodburner">
            <img src="/images/david_cleaning_woodburner_2.jpg" alt="cleaning woodburner">
            <img src="/images/david_cleaning_woodburner_3.png" alt="cleaning woodburner">
            <img src="/images/woodburner_in_inglenook_4.png" alt="cleaning inglenook">
            <img src="/images/woodburner_in_inglenook.jpg" alt="cleaning inglenook">
          </div>

          <div>
            <h2>Reviews</h2>
            
            
              <!-- <div>
                <vue-slick-carousel :arrows="true" :autoplay="true" :autoplaySpeed="3000" :dots="true" :slides-to-show="1" :infinite="true">   
                  
                  <div v-for="(quote, index) in quotes" :key="index" class="text-slide">     
                    
                    <p>{{ quote }}</p>   
                  
                  </div> 
                
                </vue-slick-carousel>
              </div> -->
            

            <div class="row">
              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <!-- <img
                    class="card-img-top"
                    src="/images/sos-56.jpg"
                    alt="Steven Jackson wearing company jacket"
                  /> -->

                  <div class="card-body">
                    <p class="card-subtitle mb-2"><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i></p>
                    <p class="card-text">
                      We use this company yearly to clean our wood burner. David is a very pleasant man who does a great job. Great value. 
                      When you contact this company Mel is so pleasant and helpful. They always arrive on time or if running late will call and let you know. 
                      Very professional and we would highly recommend to anyone who needs their wood burner or chimney cleaned. No mess and always careful to make sure they will be none. 
                      And now tonight we are looking forward to snuggling up to our fire. Thank you.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-lg-4">
                <div class="card">
                  <!-- <img
                    class="card-img-top"
                    src="/images/sos-57.jpg"
                    alt="Jake Batley wearing company jacket"
                  /> -->

                  <div class="card-body">
                    <p class="card-subtitle mb-2"><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i></p>
                    <p class="card-text">
                      David attended to our chimney and woodburner this afternoon. A pleasant and professional gentleman who did the work diligently and remained cheerful 
                      despite the nest accumulation in the stove. Highly recommended..
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 col-lg-4">
                <div class="card">
              

                  <div class="card-body">
                    <p class="card-subtitle mb-2"><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i></p>
                    <p class="card-text">
                      David was polite, professional and worked efficiently given the awkwardness of our Chimney. (Plus the dog getting the way..) 
                      Really grateful for his services and would recommend Eco Sweep 100%.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 col-lg-4">
                <div class="card">
              

                  <div class="card-body">
                    <p class="card-subtitle mb-2"><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i></p>
                    <p class="card-text">
                      Mr Bryant does an excellent job and has been doing so for us for 10+ years. at first with open fire and last 5years for a woodburner. 
                      He does a nice clean job, checks the flue is OK and is very pleasant and also happy. 
                      I am surprised to read the 2 bad reviews on here as I cannot imagine it to be the same man ! 
                      I don't usually leave reviews but felt I had to this time. He arrives on time or contacts you to say if running late as well. 
                      I recommend him to anyone enquires. He is also recommended by the business we bought the woodburner from.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 col-lg-4">
                <div class="card">
              

                  <div class="card-body">
                    <p class="card-subtitle mb-2"><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i></p>
                    <p class="card-text">
                      Having had a chimney swept in a previous house involving a lot if mess, this was the complete opposite. 
                      It was quick, there was absolutely no mess and great value. I would highly recommend to anyone.
                    </p>
                  </div>
                </div>
              </div>

              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentPage from '@/components/partials/ContentPage.vue'
import VueSlickCarousel from "vue-slick-carousel";

export default {
  name: 'about-me',
  components: {
    ContentPage,
    VueSlickCarousel
  },
  data() {
      return {
        quotes: [
          "We use this company yearly to clean our wood burner. David is a very pleasant man who does a great job. Great value. When you contact this company Mel is so pleasant and helpful. They always arrive on time or if running late will call and let you know. Very professional and we would highly recommend to anyone who needs their wood burner or chimney cleaned. No mess and always careful to make sure they will be none. And now tonight we are looking forward to snuggling up to our fire. Thank you.",
          "David attended to our chimney and woodburner this afternoon. A pleasant and professional gentleman who did the work diligently and remained cheerful despite the nest accumulation in the stove. Highly recommended.",
          "David was polite, professional and worked efficiently given the awkwardness of our Chimney. (Plus the dog getting the way..) Really grateful for his services and would recommend Eco Sweep 100%.",
          "Mr Bryant does an excellent job and has been doing so for us for 10+ years. at first with open fire and last 5years for a woodburner. He does a nice clean job, checks the flue is OK and is very pleasant and also happy. I am surprised to read the 2 bad reviews on here as I cannot imagine it to be the same man ! I don't usually leave reviews but felt I had to this time. He arrives on time or contacts you to say if running late as well. I recommend him to anyone enquires. He is also recommended by the business we bought the woodburner from.",
          "Having had a chimney swept in a previous house involving a lot if mess, this was the complete opposite. It was quick, there was absolutely no mess and great value. I would highly recommend to anyone."
        ]
      };
    }
  };  
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/breakpoints";
@import "../../assets/styles/variables/colors";
@import "slick-carousel/slick/slick.css";
@import "slick-carousel/slick/slick-theme.css";

.content {
  padding-top: 64px;
  padding-bottom: 64px;
  background-color: $clr-theme-light-gray;
}

.card {
  height: 100%;

  border: 0;
  background-color: #f5f5f5;
  box-shadow: $shadow;
  

  &-body {
    border-right: 20px solid $clr-theme-green;
  }

  &-title {
    color: $clr-theme-green;
    font-weight: 700;
  }

  &-subtitle {
    font-size: 18px;
  }

  &-text {
    font-weight: 400;
  }
}

.mb-2 {
  margin-bottom: 1rem !important;
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 5rem;

  > * {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .top-description {
    position: relative;
    p {
      font-size: 1.2rem;
    }
  }

  .ChooseUsGallary {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    gap: 10px;


      img {
        height: 200px;
        width: 200px;
        top: 1070px;
        border-radius: 10px 10px 10px 10px;

      @media (min-width: $xs-breakpoint) {
        height: 220px;
        width: 220px;
      }

      @media (min-width: $sm-breakpoint) {
        height: 230px;
        width: 230px;
      }

      @media (min-width: $sm-md-breakpoint) {
        height: 200px;
        width: 200px;
      }

      @media (min-width: $md-breakpoint) {
        height: 260px;
        width: 260px;
      }

      @media (min-width: $lg-breakpoint) {
        height: 320px;
        width: 320px;
      }
    }
  }
}

.list {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  font-size: 1.2rem;

  font-weight: 500;

  strong {
    font-weight: 700;
  }
}

.row {
  row-gap: 20px;
}

.text-slide {
  padding: 20px;
  font-size: 1.5em;
  text-align: center;
  color: #333;
}

.vue-slick-carousel {
  width: 100%;
  height: auto;
}

.fa-star {
  color: gold;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/WhyChooseUs.vue